import { Global } from '../Global';

const now = Date.now();
const day = 24 * 60 * 60 * 1000;

Global.setMockData('messageSyncAll', {
  updates: [
    {
      chatRoom: {
        id: 1,
        avatar: '',
        name: '',
        isGroup: false,
        lastActiveTime: new Date(now - day),
        totalMessageCount: 2,
        readSeqMap: {},
        memberRoleMap: { B10001: 'buyer', S10002: 'seller' },
      },
      messages: [
        {
          id: 1,
          seqInRoom: 1,
          roomId: 1,
          fromUserId: 'S10002',
          content: '您好，有什么可以帮您？',
          time: new Date(now - 2 * day),
          isWithdraw: false,
          isSystem: false,
          isCard: false,
          createTime: new Date(now - 2 * day),
          updateTime: new Date(now - 2 * day),
        },
        {
          id: 2,
          seqInRoom: 2,
          roomId: 1,
          fromUserId: 'B10001',
          content: '你好，想咨询一下服务。',
          time: new Date(now - day),
          isWithdraw: false,
          isSystem: false,
          isCard: false,
          createTime: new Date(now - day),
          updateTime: new Date(now - day),
        },
      ],
    },
  ],
  lastSyncTime: new Date(),
  hasMore: false,
});
